module.exports = __webpack_public_path__ + "img/sbp_white.2333728f.svg";